import { loadMenu } from '@/api/navItems';
const NavUtils = {
  data() {
    return {
      isActive: false,
      menuItems: []
    };
  },
  methods: {
    revealMenu() {
      this.isActive = true;
    },
    closeMenu() {
      this.isActive = false;
    },
    async updateMenu(position, lang) {
      let menu = await loadMenu(position, lang.iso_code);
      this.menuItems = menu[0]['menuItem'];
    }
  }
};

export default NavUtils;
